import { PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EamServiceScheduleTaskPermissionSet {
  View = 'eam_service_schedule_task_view',
  Write = 'eam_service_schedule_task_write',
}

export const EamServiceScheduleTaskPermissions = {
  [EamServiceScheduleTaskPermissionSet.View]: [PermissionType.GET_ANY_EAM_SERVICE_SCHEDULE_TASK],
  [EamServiceScheduleTaskPermissionSet.Write]: [PermissionType.WRITE_ANY_EAM_SERVICE_SCHEDULE_TASK],
}

export const eamServiceScheduleTaskPermissionSetGrouping = {
  key: PermissionSetGroupingKey.EamServiceScheduleTask,
  active: EamServiceScheduleTaskPermissions,
  unAssignablePermissionSets: [],
}
